import React, { useState } from "react";
import "./Nav.css";
import Panier from "./Panier"; // Import du panier
import Section from "./Section";
import fond from "../img/fond.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping,faUser,faBars } from '@fortawesome/free-solid-svg-icons';
import Oeil from "./Oeil";
import { useNavigate } from "react-router-dom";


const Nav: React.FC<{ openCommandeModal: () => void }> = ({ openCommandeModal }) => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <>
      <div className="Nav" style={{backgroundImage:fond,backgroundRepeat:"repeat"}}>
        <div className="NavContent">
          <div >
            <Oeil></Oeil>
            {/* <FontAwesomeIcon icon={faBars} style={{marginLeft:"20px"}} /> */}
            {/* <img src={Logo} alt="logo"></img> */}
          </div>
          <div className="celeste">
            <h2 onClick={() => navigate("/")} style={{cursor:"pointer"}}>Celeste Favaro</h2>
          </div>
          
          <div >
            <FontAwesomeIcon 
              icon={faUser} 
              style={{marginRight:"20px",cursor:"pointer"}}
              onClick={()=> navigate("/login")}
            />
            
            <FontAwesomeIcon 
              icon={faBagShopping} 
              style={{marginRight:"20px",cursor:"pointer"}}
              onClick={()=> setIsSidebarOpen(true)} />
          </div>
        </div>
      </div>

      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setIsSidebarOpen(false)}>
          ✖
        </button>
        <Section nom="Mon panier"></Section>
        <Panier
          closeSideBar={() => setIsSidebarOpen(false)}
          onOpenCommande={openCommandeModal} // ✅ ouvre la modale commande
        />
      </div>

      {/* Overlay pour fermer le panier en cliquant à l'extérieur */}
      {isSidebarOpen && (
        <div className={`overlay ${isSidebarOpen ? "visible" : ""}`} onClick={() => setIsSidebarOpen(false)}></div>
      )}
    </>
  );
};

export default Nav;
